import type { PacingState } from "../hooks/useInterviewPacing.ts";

function fmt(sec: number): string {
  const m = String(Math.floor(sec / 60)).padStart(2, "0");
  const s = String(sec % 60).padStart(2, "0");
  return `${m}:${s}`;
}

/** Top progress timeline: Introduction → Questions → Wrap-up, driven by elapsed time. */
export function PhaseTimeline({ pacing }: { pacing: PacingState }) {
  const phases: { key: PacingState["phase"]; label: string }[] = [
    { key: "intro", label: "Introduction (~5-6 min)" },
    { key: "questions", label: "Questions (~30 min)" },
    { key: "wrapup", label: "Wrap-up" },
  ];
  return (
    <div style={{ padding: "12px 20px", borderBottom: "1px solid var(--border-1)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <div style={{ display: "flex", gap: 16 }}>
          {phases.map((p) => (
            <span
              key={p.key}
              style={{
                fontSize: 13,
                fontWeight: pacing.phase === p.key ? 700 : 400,
                color: pacing.phase === p.key ? "#7627bb" : "var(--text-3)",
              }}
            >
              {p.label}
            </span>
          ))}
        </div>
        <span style={{ fontFamily: "var(--font-mono)", fontSize: 14 }}>{fmt(pacing.elapsedSec)}</span>
      </div>
      <div style={{ height: 6, background: "var(--surface-2)", borderRadius: 3, overflow: "hidden" }}>
        <div
          style={{
            width: `${Math.round(pacing.progress * 100)}%`,
            height: "100%",
            background: "#7627bb",
            transition: "width .5s",
          }}
        />
      </div>
    </div>
  );
}
